<template>
  <div :class="{ 'flex-grow-1': !stickyTimer || (stickyTimer && !endsWithinDay) }">
    <div v-if="bannerDetails.svg" class="p-1">
      <img :src="svgSrc" :alt="bannerDetails.text">
    </div>
    <div
      v-else-if="stickyTimer && endsWithinDay"
      class="pdp-banner-timer"
      :class="[bannerDetails.text_color]"
    >
        <span class="pdp-text mobile-sticky-banner d-inline-block my-auto">
          {{ stickyTimerText }}
        </span>
        <Countdown
          v-if="displayTimer"
          :date="bannerDetails.endDate"
          :display-labels="false"
          for-timer-experiment
          :hide-hours="endsWithin5Mins"
          class="ml-1"
        />
    </div>
    <div
      v-else
      :class="[bannerDetails.text_color, { 'pdp-banner-timer': displayTimer }]"
    >
      <div class="align-items-center d-flex">
        <span class="pdp-text pdp-banner-content d-inline-block my-auto">
          {{ bannerText }}
        </span>
        <TooltipIcon
          v-if="bannerDetails.tooltip"
          :tooltip-id="tooltipId"
          :tooltip-text="bannerDetails.tooltip"
          tooltip-type="deal_banner"
          class="ml-2"
        />
      </div>
      <Countdown
        v-if="displayTimer"
        :date="bannerDetails.endDate"
        :display-labels="false"
      />
    </div>
  </div>
</template>

<script>
import moment from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import SumoDaySvg from '../../../static/images/svg/sumo_day_2022.svg';
import BlackFridaySVG from '../../static/campaigns/black-friday-badge.svg';

moment.extend(relativeTime);

export default {
  name: 'DealBannerContent',
  components: {
    TooltipIcon: () => import('../common/TooltipIcon.vue'),
    Countdown: () => import('../utilities/Countdown.vue'),
  },
  props: {
    bannerDetails: {
      type: Object,
      required: true,
    },
    tooltipId: {
      type: String,
      required: true,
    },
    displayTimer: {
      type: Boolean,
      default: false,
    },
    stickyTimer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    svgSrc() {
      if (this.bannerDetails.svg === 'sumo_day') {
        return SumoDaySvg;
      }

      if (this.bannerDetails.svg === 'black_friday') {
        return BlackFridaySVG;
      }

      return null;
    },
    endsWithinDay() {
      return this.endsWithin(1, 'days');
    },
    endsWithin5Mins() {
      return this.endsWithin(5, 'minutes');
    },
  },
  created() {
    this.bannerText = this.bannerDetails?.text;
    this.stickyTimerText = '';

    if (this.bannerDetails?.text === 'Ending soon') {
      this.bannerText = `Offer ends ${moment(this.bannerDetails.endDate).fromNow()}`;

      if (this.endsWithinDay) {
        this.stickyTimerText = 'Hurry, deal ends in';
      }
    }
  },
  methods: {
    endsWithin(num, metric) {
      if (!this.bannerDetails?.endDate) return false;

      return moment(this.bannerDetails.endDate) < moment().add(num, metric);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~/styles/utils/breakpoints';

  .pdp-banner-content {
    font-family: 'Barlow', sans-serif !important;
    font-weight: 500;
  }

  .mobile-sticky-banner {
    font-family: 'Roboto', sans-serif !important;
    font-weight: 500;
  }

  .pdp-banner-timer {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
  }

  .pdp-banner-timer-text {
    font-family: 'Barlow', sans-serif !important;
    font-size: 1rem !important;
  }

  // change countdown default font styles
  .pdp-banner-timer ::v-deep .timer-number {
    font-size: 1rem !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 500;
    line-height: 24px;
  }

  @include media-breakpoint-up(lg) {
    .pdp-banner-content {
      padding: 4px 0;
    }
  }
</style>
